var map = {
	"./1.jpg": 2480,
	"./2.jpg": 6207,
	"./3.jpg": 8146,
	"./4.jpg": 3377,
	"./5.jpg": 1572,
	"./6.jpg": 7635,
	"./7.jpg": 7526,
	"./8.jpg": 4341,
	"./9.jpg": 24
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1106;